import { Falcon } from '@pocketlaw/tetris/macro';
import { ListButton } from '../ListButton';
export function AccessButton() {
    return <ListButton settingsKey="access" icon={<Falcon icon="lock"/>}/>;
}
